import { createBrowserRouter, Navigate } from "react-router-dom";

import PublicOnlyRoute from "../shared/routing/PublicOnlyRoute";
import ProtectedRoute from "../shared/routing/ProtectedRoute";
import AdminRoute from "../shared/routing/AdminRoute";
import AppShell from "../shared/layout/AppShell";

import AuthLayout from "../features/auth/components/AuthLayout";
import LoginPage from "../features/auth/pages/LoginPage";
import SignUpPage from "../features/auth/pages/SignUpPage";
import ResetPasswordPage from "../features/auth/pages/ResetPasswordPage";
import VerifyEmailPage from "../features/auth/pages/VerifyEmailPage";
import GoogleCallbackPage from "../features/auth/pages/GoogleCallbackPage";

import DashboardPage from "../features/dashboard/pages/DashboardPage";
import RecebiveisPage from "../features/recebiveis/pages/RecebiveisPage";
import VinculosListPage from "../features/vinculos/pages/VinculosListPage";
import VinculoDetailPage from "../features/vinculos/pages/VinculoDetailPage";
import CalendarioPage from "../features/calendario/pages/CalendarioPage";
import RelatoriosPage from "../features/relatorios/pages/RelatoriosPage";
import KpisPage from "../features/kpis/pages/KpisPage";
import PerfilPage from "../features/perfil/pages/PerfilPage";
import CheckoutReturnPage from "../features/assinatura/pages/CheckoutReturnPage";
import AdminOverviewPage from "../features/admin/pages/AdminOverviewPage";
import AdminUsersPage from "../features/admin/pages/AdminUsersPage";
import AdminFeedbacksPage from "../features/admin/pages/AdminFeedbacksPage";

import NotFoundPage from "../pages/NotFoundPage";

// Rotas alinhadas ao path que o backend hoje efetivamente envia por e-mail
// (pkg/email/sender.go -> APP_URL + "/verify-email?token=" e "/reset-password?token=") —
// por isso ficam FORA do prefixo /auth de propósito, embora renderizem via AuthLayout.
const router = createBrowserRouter([
  {
    path: "/auth",
    element: (
      <PublicOnlyRoute>
        <AuthLayout />
      </PublicOnlyRoute>
    ),
    children: [
      { index: true, element: <Navigate to="login" replace /> },
      { path: "login", element: <LoginPage /> },
      { path: "signup", element: <SignUpPage /> },
      { path: "google", element: <GoogleCallbackPage /> },
    ],
  },
  {
    path: "/reset-password",
    element: (
      <PublicOnlyRoute>
        <AuthLayout>
          <ResetPasswordPage />
        </AuthLayout>
      </PublicOnlyRoute>
    ),
  },
  {
    path: "/verify-email",
    element: (
      <AuthLayout>
        <VerifyEmailPage />
      </AuthLayout>
    ),
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <AppShell />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Navigate to="dashboard" replace /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "recebiveis", element: <RecebiveisPage /> },
      { path: "vinculos", element: <VinculosListPage /> },
      { path: "vinculos/:id", element: <VinculoDetailPage /> },
      { path: "calendario", element: <CalendarioPage /> },
      { path: "relatorios", element: <RelatoriosPage /> },
      { path: "kpis", element: <KpisPage /> },
      { path: "perfil", element: <PerfilPage /> },
      { path: "assinatura/retorno", element: <CheckoutReturnPage /> },
      {
        path: "admin",
        element: (
          <AdminRoute>
            <AdminOverviewPage />
          </AdminRoute>
        ),
      },
      {
        path: "admin/usuarios",
        element: (
          <AdminRoute>
            <AdminUsersPage />
          </AdminRoute>
        ),
      },
      {
        path: "admin/feedbacks",
        element: (
          <AdminRoute>
            <AdminFeedbacksPage />
          </AdminRoute>
        ),
      },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);

export default router;
